module.exports = __webpack_public_path__ + "img/5.fa8a0b9c.jpg";